export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/mgnifireIcon.8d3f06b5.svg","height":20,"width":21,"blurWidth":0,"blurHeight":0};